import { z } from 'zod';
/**
 * Liveness: the process is up. Never includes secrets or connection strings.
 */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.enum(['api', 'worker']),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    timestamp: z.iso.datetime(),
});
export const dependencyStatusSchema = z.object({
    status: z.enum(['up', 'down']),
    latencyMs: z.number().nonnegative().optional(),
    detail: z.string().optional(),
});
/**
 * Readiness: dependencies reachable. `detail` is a short, non-sensitive note
 * (e.g. pgvector version). HTTP 503 when status is "degraded".
 */
export const readinessResponseSchema = z.object({
    status: z.enum(['ready', 'degraded']),
    service: z.enum(['api', 'worker']),
    checks: z.object({
        database: dependencyStatusSchema,
        redis: dependencyStatusSchema,
        /** Worker only: BullMQ worker loop is running. */
        queue: dependencyStatusSchema.optional(),
    }),
    timestamp: z.iso.datetime(),
});
//# sourceMappingURL=health.js.map